module.exports = {"en":["qwertyuiop","asdfghjkl","zxcvbnm"],"fr":["azertyuiop","qsdfghjklm","wxcvbn"],"da":["qwertyuiopå","asdfghjklæø","zxcvbnm"],"de":["qwertzuiopü","asdfghjklöä","yxcvbnm"],"pl":["qwertyuiopęó","asdfghjkląśł","zxcvbnmżźćń"],"pt":["qwertyuiop","asdfghjklç","zxcvbnm"],"ru":["йцукенгшщзх","фывапролджэ","ячсмитьбюъ"],"es":["qwertyuiop","asdfghjklñ","zxcvbnm"],"el":[";ςερτυθιοπ","ασδφγηξκλ","ζχψωβνμ"]}


//////////////////
// WEBPACK FOOTER
// ./src/keyboards.json
// module id = 6
// module chunks = 0